// extracted by mini-css-extract-plugin
export default {"drawerSection":"Invoices_drawerSection__F+LAf"};